import { LineItemTextField } from "components/formFields/LineItemTextField";
import { LineTableCell } from "components/formFields/LineTableCell";

export function LineDescription(props) {
  const { value, onValueChange, maxLength, lineReadOnly = false } = props;

  if (lineReadOnly) {
    return (
      <LineTableCell
        sx={{
          minWidth: "24rem",
          minHeight: "2rem",
          fontSize: "0.8125rem",
          padding: "8px 14px",
          whiteSpace: "pre-wrap",
          wordBreak: "break-word",
          display: "-webkit-box",
          WebkitLineClamp: 4,
          WebkitBoxOrient: "vertical",
          overflow: "auto",
          maxHeight: "6rem", // Approximate height for 4 lines
          border: "none",
          backgroundColor: "background.lineItems !important",
        }}
      >
        {value || ""}
      </LineTableCell>
    );
  }

  return (
    <LineItemTextField
      resize
      multiline
      name="description"
      maxRows={4}
      value={value || ""}
      onValueChange={onValueChange}
      maxLength={maxLength}
      dataTesting="description"
    />
  );
}
